import { useState, useEffect, useCallback } from 'react';
import { CountryCodeConfig } from '@/data/countryCodes';

/**
 * Hook for filtering country codes by search term
 */
export function useCountryFilter(countryList: CountryCodeConfig[]) {
  const [filteredList, setFilteredList] = useState<CountryCodeConfig[]>(countryList);
  const [filter, setFilterState] = useState('');

  useEffect(() => {
    setFilteredList(countryList);
    setFilterState('');
  }, [countryList]);

  const setFilter = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      const value = event.target.value;
      setFilterState(value);
      
      if (value.trim() === '') {
        setFilteredList(countryList);
      } else {
        const searchTerm = value.toLowerCase();
        const filtered = countryList.filter(({ name, code }) =>
          name.toLowerCase().includes(searchTerm) ||
          code.toLowerCase().includes(searchTerm)
        );
        setFilteredList(filtered);
      }
    },
    [countryList]
  );

  return { filter, setFilter, filteredList };
}

